var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',_vm._b({},'v-input',_vm.$props,false),[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }